type Props = {
  color: string
  title: string
  value: number
  className?: string
}

const StockSummaryCard = ({color, title, value, className}: Props) => {
  return (
    <div className={`card bg-light-${color} ${className || ''}`}>
      <div className='card-body'>
        <div className={`fw-bold text-${color} fs-6 mb-3`}>{title}</div>

        <div className='fs-1 fw-bolder text-dark'>{value}</div>
      </div>
    </div>
  )
}

export default StockSummaryCard
